<template>
<div :title="t('headerTools.notice')" class="common-header-notice" v-clickoutside="hidePanel">
  <div
    :class="[
      'notice-button',
      { active: visiable }
    ]"
    @click="visiable = !visiable"
  >
    <icon class="notice" type="notice" size="22"></icon>
    <sup class="count" v-if="unreadCount > 0">{{ unreadCount > 99 ? '99+' : unreadCount }}</sup>
  </div>

  <div class="notice-panel" v-show="visiable">
    <header>
      <div class="title">
        {{t('notice.noticeCount', {count})}}
      </div>
      <div class="all-read" v-if="count > 0 && allRead" @click="onAllRead">{{t('notice.allRead')}}</div>
    </header>

    <main>
      <slot name="notice-list">
        <div class="no-notice" v-if="count <= 0">
          {{t('notice.noNotice')}}
        </div>
        <ul class="notice-list" v-if="count > 0">
          <li
            v-for="item of list"
            :key="item.id"
            :track-by="item.id"
            :class="['notice-item', { read: item.read }]"
            @click="onRead(item)"
          >
            <div class="category pre-line">{{transferHtmltoText(item.category)}}</div>
            <div class="digest pre-line" v-if="item.digest">{{transferHtmltoText(item.digest)}}</div>
            <div class="detail pre-line" v-if="item.detail">{{transferHtmltoText(item.detail)}}</div>
            <div class="time" v-if="item.time">{{ item.time }}</div>
          </li>
        </ul>
      </slot>
    </main>

    <footer v-if="count > 0">
      <span class="all-notice" @click="goNotice">{{t('notice.allNotice')}}</span>
    </footer>
  </div>
</div>
</template>

<script>
import Icon from '../../components/icon';
import clickoutside from '../../directives/clickoutside';
import i18nHandle from '../../locales';

export default {
  components: {
    Icon,
  },
  directives: {
    clickoutside,
  },
  props: {
    unreadCount: {
      type: [Number, String],
      default() {
        return 0;
      },
    },
    count: {
      type: [Number, String],
      default() {
        return 0;
      },
    },
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    allRead: {
      type: Boolean,
      default: true,
    },
    onAllRead: {
      type: Function,
      default() {},
    },
    onRead: {
      type: Function,
      default() {},
    },
    goNotice: {
      type: Function,
      default() {},
    },
  },
  data() {
    return {
      visiable: false,
    };
  },
  methods: {
    transferHtmltoText(html) {
      const div = document.createElement('div')
      div.innerHTML = html
      return div.innerText
    },
    hidePanel() {
      this.visiable = false;
    },
    t: i18nHandle.t,
  },
};
</script>

<style lang="scss">
@import '../../assets/styles/_variable';

.common-header-notice {
  position: relative;
  .pre-line {
    white-space: pre-line;
  }
  .notice-button {
    cursor: pointer;
    &.active,
    &:hover {
      .notice {
        color: #2997f5;
      }
    }

    .notice {
      color: #909090;
    }

    .count {
      position: absolute;
      top: 4px;
      left: 14px;
      min-width: 14px;
      color: #fff;
      padding: 2px 3px;
      border-radius: 8px;
      line-height: normal;
      text-align: center;
      box-sizing: content-box;
      background-color: #f26363;
    }
  }

  .notice-panel {
    position: absolute;
    top: calc(#{$layoutHeaderHeight} + -20px);
    right: -20px;
    width: 360px;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.26);

    &::before {
      position: absolute;
      top: -6px;
      right: 26px;
      width: 12px;
      height: 12px;
      background-color: #fff;
      box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.26);
      content: '';
      transform: rotate(45deg);
    }

    &::after {
      position: absolute;
      top: 0;
      right: 20px;
      width: 25px;
      height: 12px;
      background-color: #fff;
      content: '';
    }

    & > header {
      display: flex;
      height: 46px;
      padding: 0 20px;
      border-bottom: 1px solid #e2e4e8;

      justify-content: space-between;
      align-items: center;
      .title {
        color: $mainColor;
        font-size: 14px;
        font-weight: bold;
      }
      .all-read {
        color: #748099;
        font-size: 12px;
        cursor: pointer;
      }
    }

    & > main {
      .no-notice {
        display: flex;
        height: 102px;
        color: #adb4c3;
        font-size: 18px;

        justify-content: center;
        align-items: center;
      }
      .notice-list {
        margin: 0;
        padding: 0;
        .notice-item {
          padding: 16px 20px;
          font-size: 14px;
          line-height: 20px;
          list-style: none;
          cursor: pointer;
          color: $mainColor;
          &:not(:last-child) {
            border-bottom: 1px solid #e2e4e8;
          }
          .category {
            font-weight: bold;
            padding-bottom: 4px;
          }
          .time {
            padding-top: 4px;
          }
          &.read {
            .category,
            .digest,
            .detail,
            .time {
              color: #9e9e9e;
            }
            .category {
              font-weight: normal;
            }
          }
        }
        .category,
        .digest {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }

    & > footer {
      display: flex;
      height: 42px;
      border-top: 1px solid #e2e4e8;
      line-height: 42px;

      justify-content: center;
      align-items: center;
      .all-notice {
        color: #748099;
        cursor: pointer;
      }
    }
  }
}
</style>
